import React, {useEffect, useReducer, useState} from "react";
import styled from "styled-components";
import ChannelHeader from "./ChannelHeader";
import InputMessage from "./InputMessage";
import {
    getValueFromAllowToChat,
    readOnlyChannel,
    sendFileFromConversation,
    sendMessageFromConversation,
    setItemToStorage,
    updateReadOnlyChannel
} from "./utils";
import {getChatIdentifier} from "../Auth";
import ChannelSettings from "./ChannelSettings";
import TypingIndicator from "./TypingIndicator";
import ChannelChatMessages from "./ChannelChatMessages";
import {MessageOfConversation} from "./types";
import {useChatStoreReducer} from "./store";
import {getUserId, showErrorToast, showToast} from "../Utilities";

export type StateChannelChat = {
    conversation: any;
    messages: Array<MessageOfConversation>;
    identity: string | null;
    files: Array<any>;
    openFileModal: boolean;
    loading: boolean;
    openChannelSettings: boolean;
    previousIndex: number;
    lastIndex: number;
    hasPreviousPage: boolean;
    init: boolean;
    filter: any;
};

// type ActionChatWindow =
//     | { type: "setFilter"; filter: any }
//     | { type: "messageAdded"; message: MessageOfConversation }
//     | { type: "setInitialMessages"; }
//     | { type: "prependMessages" }
//     | { type: "messageRemoved" }
//     | { type: "messageUpdated"; init: boolean; }
//     | { type: "sendMessage"; isReviewing: boolean; }
//     | { type: "setChannel"; message: MessageOfChannel; }
//     | { type: "setFiles"; message: MessageOfChannel; }
//     ;

function reducer(state: StateChannelChat, action: any): StateChannelChat {
    let files: any[] = [];
    let formData;
    switch (action.type) {
        case "setFilter":
            return {...state, filter: action.filter};
        case "messageAdded":
            let element = action.message;
            if (state.messages.length - 1 >= 0 && state.messages[state.messages.length - 1].sid === element.sid) {
                return state;
            }
            return {...state, messages: [...state.messages, element]};
        case "setInitialMessages":
            return {
                ...state,
                messages: action.messages,
                init: true,
                previousIndex: action.previousIndex,
                hasPreviousPage: action.hasPreviousPage,
                lastIndex: action.lastIndex
            };
        case "prependMessages":
            let tmp = [...action.messages, ...state.messages];
            let tmpInit = false;
            if (tmp.length > 1200) {
                tmpInit = true;
            }
            return {
                ...state, messages: tmp,
                init: tmpInit,
                previousIndex: action.previousIndex,
                hasPreviousPage: action.hasPreviousPage,
            };
        case "messageRemoved":
            // let indexToRemove = state.messages.findIndex(item => item.sid === action.messageSid);
            // console.log({indexToRemove});
            // state.messages.splice(indexToRemove, 1);
            return {...state, messages: state.messages.filter(item => item.sid !== action.messageSid)};
        case "messageUpdated":
            return {
                ...state, messages: state.messages.map(item => {
                    if (item.sid === action.message.sid) {
                        return action.message;
                    }
                    return item;
                })
            };
        case "sendMessage":
            if (state.conversation && state.filter) {
                sendMessageFromConversation(state.conversation, state.filter, action.content).then(r => r);
            }
            return {...state};
        case "setChannel":
            return {...state, conversation: action.conversation};
        case "setFiles":
            return {...state, files: action.files, openFileModal: action.openFileModal};
        case "removeFile":
            state.files.splice(action.removeIndex, 1);
            return {...state};
        case "sendByS3":
            let promisesForFiles: any[] = [];
            for (let index = 0; index < state.files.length; index++) {
                formData = new FormData();
                formData.append("file", state.files[index]);
                formData.append("name", state.files[index].name);
                files[index] = formData;
                promisesForFiles.push(sendFileFromConversation(state.conversation, files[index], state.files[index]));
            }
            Promise.all(promisesForFiles).then();
            return {...state, files: [], openFileModal: action.openFileModal};
        case "sendFiles":
            for (let index = 0; index < state.files.length; index++) {
                formData = new FormData();
                formData.append(state.files[index].name, state.files[index]);
                // @ts-ignore
                files[index] = formData;
            }
            for (let index = 0; index < state.files.length; index++) {
                sendMessageFromConversation(state.conversation, state.filter, files[index]).then();
            }
            return {...state, files: [], openFileModal: action.openFileModal};
        case "setOpen":
            return {...state, openFileModal: action.openFileModal};
        case "setLoading":
            return {...state, loading: false};
        case "setPreviousIndex":
            return {...state, previousIndex: action.previousIndex};
        case "setLastIndex":
            return {...state, lastIndex: action.lastIndex};
        case "setHasPreviousPage":
            return {...state, hasPreviousPage: action.hasPreviousPage};
        case "setInit":
            return {...state, init: action.init};
        case "setOpenChannelSettings":
            return {...state, openChannelSettings: action.openChannelSettings};
        default:
            return state;
    }
}


const ChannelChatContainer = styled.div`
    display: grid;
    width: 340px;
    height: calc(8px + 56px + 165px + 330px);
    box-shadow: 0 3px 6px #00000029;
    background-color: white;
    min-height: calc(8px + 56px + 165px + 330px);
    align-content: flex-start;
`;

type Props = {
    conversation: Conversation;
};

function ChannelChatWindow(props: Props) {
    const {conversation} = props;
    const {state: chatState} = useChatStoreReducer();
    const {allowToChat} = chatState;
    const [showInput, setShowInput] = useState(getValueFromAllowToChat());
    const initialState: StateChannelChat = {
        conversation: conversation,
        messages: [],
        identity: getChatIdentifier(),
        files: [],
        openFileModal: false,
        loading: false,
        openChannelSettings: false,
        previousIndex: 0,
        lastIndex: 0,
        hasPreviousPage: false,
        init: false,
        filter: chatState.filter,
    };
    const [state, dispatch] = useReducer(reducer, initialState);

    useEffect(() => {
        const abortController = new AbortController();
        const checkReadOnly = async () => {
            if (conversation) {
                try {
                    // @ts-ignore
                    if (conversation.attributes.kind === 'Group' &&
                        // @ts-ignore
                        Array.isArray(conversation.attributes.permissions) &&
                        // @ts-ignore
                        conversation.attributes.permissions.length > 0) {
                        let userId = getUserId();
                        // @ts-ignore
                        let roleIds = conversation.attributes.permissions;
                        let result = await readOnlyChannel(userId, roleIds);
                        if (result.success) {
                            setShowInput(false);
                        } else {
                            setShowInput(true);
                        }
                    }
                } catch (e) {
                    await showErrorToast(e, 'Error in checking read only for conversation ' + conversation.friendlyName + '.');
                    setShowInput(true);
                }
            }
        }
        checkReadOnly().then();
        return () => {
            abortController.abort();
        };
    }, []);

    useEffect(() => {
        if (allowToChat && allowToChat.value) {
            setShowInput(allowToChat.value);
        } else {
            setShowInput(false);
        }
    }, [allowToChat.track]);

    useEffect(() => {
        const abortController = new AbortController();
        if (conversation) {
            conversation.on('updated', async (event) => {
                try {
                    // @ts-ignore
                    if (conversation.attributes.kind === 'Group') {
                        if (Array.isArray(event.updateReasons) && event.updateReasons.includes("dateUpdated")) {
                            // @ts-ignore
                            if (event.conversation.attributes &&
                                // @ts-ignore
                                Array.isArray(event.conversation.attributes.permissions)
                            ) {
                                let userId = getUserId();
                                // @ts-ignore
                                let roleIds = event.conversation.attributes.permissions;
                                // @ts-ignore
                                let result = await updateReadOnlyChannel(userId, roleIds, conversation);
                                setItemToStorage(`permissions_${conversation.sid}`, roleIds);
                                if (result.success) {
                                    await showToast({
                                        type: 'info',
                                        title: 'You are allowed to read, but not send messages in this conversation.'
                                    });
                                    setShowInput(false);
                                } else {
                                    setShowInput(true);
                                }
                            }
                        }
                    }
                } catch (e) {
                    await showErrorToast(e, 'Error in update event for conversation ' + conversation.friendlyName);
                    setShowInput(true);
                }
            });
        }
        return () => {
            abortController.abort();
        };
    }, []);

    return (
        <>
            <ChannelChatContainer data-id={"container-" + conversation.sid}>
                <ChannelHeader conversation={conversation} channelDispatch={dispatch}/>
                <ChannelChatMessages conversation={conversation} state={state} dispatch={dispatch}
                                     showInput={showInput}/>
                <TypingIndicator conversation={conversation}/>
                {showInput &&
                    <InputMessage state={state} dispatch={dispatch} conversation={conversation}
                                  allowToChat={chatState.allowToChat}/>}
            </ChannelChatContainer>
            {state.openChannelSettings && conversation &&
                <ChannelSettings conversation={conversation} channelDispatch={dispatch}/>}
        </>
    );
}

export default ChannelChatWindow;
